import { Tooltip } from '@mui/material';
import { getIntervalIndicator } from '../../utils/intervalColorUtils';
import styles from './style.module.css';

function IntervalIndicator({
  intervalType,
  intervalValue,
  size = 'medium',
  position = 'absolute',
}) {
  if (!intervalType || !intervalValue) {
    return null;
  }

  const indicator = getIntervalIndicator({ type: intervalType, value: intervalValue });

  const sizeStyles = {
    small: {
      width: '18px',
      height: '18px',
      fontSize: '10px',
    },
    medium: {
      width: '22px',
      height: '22px',
      fontSize: '11px',
    },
    large: {
      width: '26px',
      height: '26px',
      fontSize: '13px',
    },
  };

  const positionStyles =
    position === 'absolute'
      ? { position: 'absolute', top: '0px', right: '0px' }
      : { position: 'relative' };

  return (
    <Tooltip title={indicator.fullName} placement="top" arrow>
      <div
        className={styles.intervalIndicator}
        style={{
          ...positionStyles,
          ...sizeStyles[size],
          backgroundColor: indicator.color,
        }}
      >
        {indicator.abbreviation}
      </div>
    </Tooltip>
  );
}

export default IntervalIndicator;
